/* fc-anim.js — Redesign 2026 (Claude). Count-up, Scroll-Reveal, Stagger, Burger-Menü. defer. */
(function () {
  'use strict';
  var root = document.documentElement;
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var animOn = root.classList.contains('fc-anim') && !reduce;
  var countersOn = animOn && root.getAttribute('data-fc-counters') !== 'false';

  function fmt(v, dec) { return v.toFixed(dec).replace('.', ','); }

  /* Zahlen zählen hoch */
  function initCounters() {
    var els = document.querySelectorAll('[data-fc-count]');
    if (!els.length) return;
    if (!countersOn || !('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.textContent = fmt(parseFloat(e.getAttribute('data-fc-count')), +(e.getAttribute('data-fc-dec') || 0)); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        io.unobserve(en.target);
        var el = en.target, end = parseFloat(el.getAttribute('data-fc-count')) || 0, dec = +(el.getAttribute('data-fc-dec') || 0), t0 = null;
        function step(t) {
          if (!t0) t0 = t;
          var p = Math.min((t - t0) / 1400, 1); p = 1 - Math.pow(1 - p, 3);
          el.textContent = fmt(end * p, dec);
          if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      });
    }, { threshold: 0.6 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* Scroll-Reveal */
  function initReveal() {
    var els = document.querySelectorAll('[data-fc-reveal]');
    if (!els.length) return;
    if (!animOn || !('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { threshold: 0, rootMargin: '0px 0px -60px 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  /* Stagger: Kinder eines [data-fc-stagger]-Containers laufen versetzt ein.
     Der Wert ist der Versatz in ms je Kind (Standard 90, gedeckelt bei 12 Kindern). */
  function initStagger() {
    var conts = document.querySelectorAll('[data-fc-stagger]');
    if (!conts.length) return;
    function apply(c) {
      if (c.dataset.fcStaggered) return;
      c.dataset.fcStaggered = '1';
      var step = parseInt(c.getAttribute('data-fc-stagger'), 10);
      if (isNaN(step) || step < 0) step = 90;
      var kids = c.children, i;
      for (i = 0; i < kids.length; i++) {
        kids[i].style.transitionDelay = (Math.min(i, 11) * step) + 'ms';
      }
    }
    if (!animOn || !('IntersectionObserver' in window)) {
      conts.forEach(function (c) { c.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        io.unobserve(en.target);
        apply(en.target);
        en.target.classList.add('is-in');
      });
    }, { threshold: 0, rootMargin: '0px 0px -80px 0px' });
    conts.forEach(function (c) { io.observe(c); });
  }

  /* Burger-Menü */
  function initDrawer() {
    var drawer = document.querySelector('[data-fc-drawer]');
    if (!drawer) return;
    function open() { drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; }
    function close() { drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }
    document.querySelectorAll('[data-fc-open]').forEach(function (b) { b.addEventListener('click', open); });
    drawer.querySelectorAll('[data-fc-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keyup', function (e) { if (e.key === 'Escape') close(); });
  }

  /* Sticky Termin-Button (mobil) */
  function initMcta() {
    var bar = document.querySelector('[data-fc-mcta]');
    if (!bar || bar.dataset.fcReady) return;
    bar.dataset.fcReady = '1';
    document.body.classList.add('fc-has-mcta');
    var last = 0;
    function upd() {
      var y = window.pageYOffset || document.documentElement.scrollTop;
      var atEnd = (y + window.innerHeight) > (document.body.scrollHeight - 140);
      var on = y > 320 && !atEnd;
      if (on !== last) { bar.classList.toggle('is-on', on); last = on; }
    }
    window.addEventListener('scroll', upd, { passive: true });
    window.addEventListener('resize', upd);
    upd();
  }

  /* Footer-Spalten: mobil zugeklappt, ab 641px immer offen */
  function initFooterCols() {
    var cols = document.querySelectorAll('.fc-ft-col');
    if (!cols.length) return;
    function sync() {
      var mobile = window.matchMedia('(max-width:640px)').matches;
      cols.forEach(function (c) {
        if (mobile) { if (!c.dataset.fcTouched) c.open = false; }
        else { c.open = true; }
      });
    }
    cols.forEach(function (c) {
      if (c.dataset.fcReady) return;
      c.dataset.fcReady = '1';
      c.addEventListener('toggle', function () {
        if (window.matchMedia('(max-width:640px)').matches) c.dataset.fcTouched = '1';
      });
    });
    sync();
    window.addEventListener('resize', sync);
  }

  function init() { initCounters(); initReveal(); initStagger(); initDrawer(); initMcta(); initFooterCols(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();